export default __webpack_public_path__ + "static/media/img2.f9abbd56.png";